import { connect } from 'react-redux'
import ManageProject from './ManageProject'
import { setMenu } from '../../../store/menu/actions'
import { setProjectToManage } from '../../../store/setManageProject/actions'

const mapStateToProps = state => ({
  settings: state.settings,
  project: state.projectToManage
})

const mapDispatchToProps = dispatch => ({
  setMenu: menu => {
    dispatch(setMenu(menu))
  },
  setProjectToManage: project => {
    dispatch(setProjectToManage(project))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageProject)